import { Col, Row } from "antd";
import clsx from "clsx";
import { t } from "i18next";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useAuthContext } from "../../../../../../contexts/AuthContext";
import query from "../../../../../../server/constants.api";
import logger from "../../../../../../server/server";
import useFetch from "../../../../../../server/useFetch";
import { PageContent } from "../../../../../../styles/global/Pages.styled";
import Theme from "../../../../../../styles/Theme/Theme";
import { metrics } from "../../../../../../utils/dummydata";
import { orbitCamera } from "../../../../../../utils/renders/render-helper";
import { SelectAtomic } from "../../../../Atomics/SelectAtomic";
import { Widget } from "../../../../Atomics/Widget";
import { FloorVacancyComponent } from "../../../FloorVacancyComponent/FloorVacancyComponent";
import { StackedFloorsComponent } from "../../../StackedFloorsComponent/StackedFloorsComponent";

// Componente principal que exibe o histórico de consumo energético de um edifício
export const BuildingConfortDA = ({ item, currentFloor, ...props }) => {
  // Hook de tradução
  const { t } = useTranslation();
  const { user, tenant } = useAuthContext();
  const [selectedMetrics, setselectedMatrics] = useState("temperature");
  const [selectedDay, setSelectedDay] = useState();
  const [orbitCameraVal, setOrbitCamera] = useState(false);
  const [orbitControls, setOrbitControls] = useState();

  useEffect(() => {
    logger.info("User: " + user?.Username + " entered BuildingConfortDA successfully! Tenant: " + tenant);
  }, []);

  function toggleCamera() {
    orbitCamera(orbitControls, !orbitCameraVal);
    setOrbitCamera(!orbitCameraVal);
  }

  const { data: comfortData, isFetching: comfortDataIsFetching, refetch: refetchComfortData } = useFetch(
    "/registry/comfort/daily-analysis", "comfortData",
    {
      tenant: item?.tenant,
      year: null,
    },
    currentFloor?.value ?? false, null, query.middlewareURL);

  useEffect(() => {
    if (!(comfortData === undefined || comfortData === null))
      if (Object.keys(comfortData).length === 0) {
        logger.warn("User: " + user?.Username + " Tenant: " + tenant + ", comfortData is a empty object!!");
      }
  }, [comfortData]);

  const { data: roomsByFloor, isFetching: roomsByFloorIsFetching, refetch: refetchRoomsByFloor } = useFetch(
    "/registry/buildings/rooms", "roomsByFloor",
    {
      id: currentFloor?.value,
    },
    currentFloor?.value ?? false, null, query.middlewareURL);

  useEffect(() => {
    if (!(roomsByFloor === undefined || roomsByFloor === null))
      if (Object.keys(roomsByFloor).length === 0) {
        logger.warn("User: " + user?.Username + " Tenant: " + tenant + ", roomsByFloor is a empty object!");
      }
  }, [roomsByFloor]);
  // Refetch dos dados quando o mês ou ano selecionados mudam
  useEffect(() => {
    refetchComfortData();
    setOrbitCamera(false);
  }, [selectedMetrics]);

  useEffect(() => {
    refetchComfortData();
    refetchRoomsByFloor();
  }, [currentFloor?.value]);

  return (
    <>
      {/* Conteúdo da página com layout e estrutura com Col e Rows */}
      <PageContent className={clsx("building_room_details", props?.className)}>
        {/* {!isFetching ? ( //check if the data is still fetching */}
        <Row gutter={[16, 16]}>
          {/* Define o layout de linhas com largura total */}
          <Col span={24} style={{ alignContent: "center" }}>
            <Row>
              <Col span={10}>
                <h3>
                  {item?.name} | {t("Comfort").toLocaleUpperCase()}{" "}
                  {/* Changes the title to upperCase and translates it */}
                </h3>
              </Col>
              <Col span={4} offset={10} style={{ alignContent: "center" }}>
                <SelectAtomic
                  optionsData={metrics.map(x => ({ label: t(x.label), value: x.value }))}
                  handleOptionsChange={(value) => {
                    setselectedMatrics(value);
                  }}
                  defaultValue={selectedMetrics}
                  fullWidth={true}
                />
              </Col>
            </Row>
          </Col>

          {/* Widgets com dados de consumo energético */}
          <Col span={24}>
            <Row gutter={[16, 16]}>
              <Col span={10}>
                <Widget
                  className="full-h"
                  data={{
                    background: "white",
                    title: t("Heatmap"),
                    icon: null,
                    buttons: [
                      {
                        key: t("360"),
                        title: t("360º"),
                        onButtonClick: () => toggleCamera(),
                        isActive: orbitCameraVal,
                      },
                    ],
                  }}
                >
                  <div style={{ height: "480px" }}>
                    {currentFloor?.value === item?.id ? (
                      <StackedFloorsComponent
                        building={item}
                        metric={selectedMetrics}
                        setOrbitControls={setOrbitControls}
                      />
                    ) : (
                      <FloorVacancyComponent
                        building={item}
                        currentFloor={currentFloor}
                        metric={selectedMetrics}
                        setOrbitControls={setOrbitControls}
                      />
                    )}
                  </div>
                </Widget>
              </Col>
              <Col span={14}>
                <Row gutter={[16, 16]}>
                  <Col span={24}>
                    <Row gutter={[16, 16]}>
                      <Col span={12}>
                        <Widget
                          data={{
                            background: "white",
                            title: t("Average Value"),
                            icon: null,
                            charts: [
                              {
                                chartType: "bigNumberChart",
                                chartId: "bigNumberChartOne",
                                height: "111px",
                                isFetching: comfortDataIsFetching,
                                data: comfortData
                                  ? {
                                    number:
                                      comfortData[selectedMetrics][
                                        currentFloor.label
                                      ].average.toFixed(1),
                                    unit: comfortData[selectedMetrics][
                                      currentFloor.label
                                    ].unit,
                                    type: null,
                                    label: null,
                                    fluctuation: null,
                                    fluctuationText: null,
                                    bigFluctuation: false,
                                    icon: null,
                                  }
                                  : null,
                              },
                            ],
                          }}
                        />
                      </Col>
                      <Col span={12}>
                        <Widget
                          data={{
                            background: "white",
                            title: t("Ideal Value"),
                            icon: null,
                            charts: [
                              {
                                chartType: "bigNumberChart",
                                chartId: "bigNumberChartOne",
                                height: "111px",
                                isFetching: comfortDataIsFetching,
                                data: comfortData
                                  ? {
                                    number:
                                      comfortData[selectedMetrics][
                                        currentFloor.label
                                      ].ideal,
                                    unit: comfortData[selectedMetrics][
                                      currentFloor.label
                                    ].unit,
                                    type: null,
                                    label: null,
                                    fluctuation: null,
                                    fluctuationText: null,
                                    bigFluctuation: false,
                                    icon: null,
                                  }
                                  : null,
                              },
                            ],
                          }}
                        />
                      </Col>
                    </Row>
                  </Col>
                  <Col span={24}>
                    <Widget
                      data={{
                        background: "white",
                        title: t(
                          metrics.find((x) => x.value === selectedMetrics)
                            ?.label + " Variation"
                        ),
                        icon: null,
                        dropdowns:
                          !roomsByFloorIsFetching &&
                            roomsByFloor &&
                            currentFloor?.label !== item?.name
                            ? [
                              {
                                data: roomsByFloor?.map((x) => {
                                  return { label: x.name, value: x.key };
                                }),
                                value: selectedDay,
                                functionChange: (value) =>
                                  setSelectedDay(value),
                                width: "200px",
                              },
                            ]
                            : null,
                        charts: [
                          {
                            chartType: "areaChartApex",
                            chartId: "areaChartApex",
                            height: "300px",
                            isFetching: comfortDataIsFetching,
                            data: comfortData
                              ? serealizeAreaChartVariation(
                                comfortData[selectedMetrics][
                                currentFloor.label
                                ]
                              )
                              : null,
                          },
                        ],
                      }}
                    />
                  </Col>
                </Row>
              </Col>
            </Row>
          </Col>
        </Row>
        {/* ) : (
          <Flex justify="center">
            <Spinner stroke="green" size="42px" />
          </Flex> //while data is fetching, a simple spinner will show up in the page
        )} */}
      </PageContent>
    </>
  );
};

const serealizeAreaChartVariation = (data) => {
  const idealValue = data.ideal;

  const series = [
    {
      name: t("Estimated Value"),
      data: [],
    },
    {
      name: t("Real Value"),
      data: [],
    },
  ];

  Object.entries(data.values).map((x, index) => {
    const [key, value] = x;
    series[0].data.push({
      x: key,
      y: idealValue,
    });

    series[1].data.push({
      x: key,
      y: value,
    });
  });

  return {
    series: series,
    categories: null,
    xAxisType: "number",
    markerSize: 3,
    columnWidth: 20,
    colors: [
      Theme.color["temperature-real"],
      Theme.color["temperature-estimated"],
    ],
    unit: data.unit,
  };
};
